import { IPiece, ISquare, PieceType } from '../services/zodiacEngine/types';

/** Presentation only: decoy passengers must never become movable game pieces. */
export function inkAppearance(pieces: IPiece[], board: ISquare[][]): IPiece[] {
  const octopus = pieces.find(p => p.type === PieceType.Octopus);
  if (!octopus) return pieces;
  const squares = board.flat();
  if (!squares.some(s => s.Pieces.some(p => p.type === PieceType.Octopus && p.isShadow && p.isLight === octopus.isLight))) return pieces;
  const sourceSquare = squares.find(s => s.Pieces.some(p => p.type === PieceType.Octopus && !p.isShadow && p.isLight === octopus.isLight));
  const source = sourceSquare?.Pieces.find(p => p.type === PieceType.Octopus && !p.isShadow);
  if (!source) return pieces;
  const appearance = Object.assign(Object.create(Object.getPrototypeOf(octopus)), octopus, {
    isInfected: source.isInfected, isMeadowed: source.isMeadowed,
    isEntangled: source.isEntangled, isFainted: source.isFainted,
    poisonedStatus: { ...source.poisonedStatus }, zombifiedStatus: { ...source.zombifiedStatus },
    isShadowed: true,
  }) as IPiece;
  const visible = pieces.map(p => p === octopus ? appearance : p);
  const passenger = sourceSquare?.Pieces.find(p => p.type === PieceType.Virus);
  if (passenger && !visible.some(p => p.type === PieceType.Virus)) {
    visible.push(Object.assign(Object.create(Object.getPrototypeOf(passenger)), passenger, { id: `${octopus.id}:ink-passenger` }));
  }
  return visible.map(p => p.type === PieceType.Virus
    ? Object.assign(Object.create(Object.getPrototypeOf(p)), p, { isShadowed: true })
    : p);
}
